import { createBrowserRouter, Navigate, useLocation } from 'react-router';
import { RouterProvider } from 'react-router/dom';
import { Layout } from './components/Layout';
import { Home } from './routes/Home';
import { Learn } from './routes/Learn';
import { MountainPreview } from './routes/MountainPreview';
import { NotFound } from './routes/NotFound';
import { PlayBot } from './routes/PlayBot';
import { PlayIce } from './routes/PlayIce';
import { PlayIceBot } from './routes/PlayIceBot';
import { PlayOnlineMatch, PlayOnlineSetup } from './routes/PlayOnline';
import { PlayLocal } from './routes/PlayLocal';

const router = createBrowserRouter([
  {
    element: <Layout />,
    children: [
      { path: '/', element: <Home /> },
      { path: '/play/local', element: <PlayIce /> },
      { path: '/play/ice', element: <ToLocal /> },
      { path: '/play/bot', element: <PlayIceBot /> },
      { path: '/mountain', element: <PlayLocal /> },
      { path: '/mountain/bot', element: <PlayBot /> },
      { path: '/play/online', element: <PlayOnlineSetup /> },
      { path: '/play/:matchId', element: <PlayOnlineMatch /> },
      { path: '/learn', element: <Learn /> },
      { path: '/m/:seed', element: <MountainPreview /> },
      { path: '*', element: <NotFound /> },
    ],
  },
]);

/** `/play/ice` was the ice game's first address: keep old links (and their lake) working. */
function ToLocal() {
  const { search } = useLocation();
  return <Navigate to={`/play/local${search}`} replace />;
}

export function App() {
  return <RouterProvider router={router} />;
}
